"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function JointVenture() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: detailsRef,
    isVisible: detailsVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const contactBlocks = [{
    label: "CREDIT SCORE",
    content: "700+ FICO Requirement",
    secondary: "Verified credit history"
  }, {
    label: "CAPITAL",
    content: "Liquid assets available",
    secondary: "Proof of funds required"
  }, {
    label: "EXPERIENCE",
    content: "Proven track record",
    secondary: "Real estate portfolio"
  }];
  return <section data-section-id="2555" id="engine-02-joint-venture-program" className="bg-background text-foreground relative overflow-hidden min-h-[70vh] flex items-center justify-center px-6 py-24 md:py-32">
      {}
      <div className="pointer-events-none absolute -bottom-1/3 -right-1/4 w-[700px] h-[700px] rounded-lg opacity-30" style={{
      background: "radial-gradient(circle, hsl(45 100% 50% / 0.15) 0%, transparent 60%)"
    }} aria-hidden="true" />

      {}
      <div className="pointer-events-none absolute inset-0 opacity-[0.03] mix-blend-overlay" style={{
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")"
    }} aria-hidden="true" />

      <div className="relative z-10 w-full max-w-[1180px] mx-auto">
        {}
        <div ref={headerRef} className={`flex flex-col items-center text-center transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <p className="font-default text-xs md:text-sm uppercase tracking-[0.2em] text-muted-foreground mb-10 md:mb-14">
            ENGINE 02 — JOINT VENTURE PARTNERSHIP
          </p>

          <h1 className="font-default font-bold text-foreground leading-[0.95] tracking-tight mb-10 md:mb-12" style={{
          fontSize: "clamp(3rem, 9vw, 7rem)"
        }}>
            Architecting
            <br />
            <span className="font-normal text-primary">Capital</span>{" "}
            Together.
          </h1>

          <p className="font-default text-base md:text-[18px] leading-relaxed text-muted-foreground max-w-[540px] mx-auto">
            We partner with experienced investors and capital allocators to scale high-yield real estate opportunities. If you meet our institutional criteria, we provide the infrastructure to execute at scale.
          </p>
        </div>

        {}
        <div ref={detailsRef} className={`mt-20 md:mt-28 grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-10 transition-all duration-1000 delay-200 ease-out ${detailsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          {contactBlocks.map((block, i) => <div data-index={i} key={block.label} className="flex flex-col items-start text-left">
              {}
              <div className="w-12 h-px bg-primary mb-5" aria-hidden="true" />

              <p className="font-default text-xs uppercase tracking-[0.18em] text-muted-foreground mb-4">
                {block.label}
              </p>

              <p className="font-default text-[20px] leading-snug text-foreground">
                {block.content}
              </p>

              {block.secondary && <p className="font-default text-[20px] leading-snug text-muted-foreground mt-1">
                  {block.secondary}
                </p>}
            </div>)}
        </div>
      </div>
    </section>;
}